export default __webpack_public_path__ + "9bdb2d9ac9bb38642a1e82e52b65ef18.svg";